import { useEffect, useState } from 'react';
import { DateTime } from 'luxon';
import { useDispatch, useSelector } from 'react-redux';
import { useDebounce } from 'react-use';

import { usePatchProjectMutation } from '@greenkub-fronts/data-access';
import {
  AppDispatch,
  FixMe,
  Project,
  RootState,
} from '@greenkub-fronts/shared/interface';
import {
  addErrorMessage,
  addPositiveMessage,
} from '@greenkub-fronts/domain/snackbar';
import {
  getCurrentProject,
  openModalSignature,
} from '@greenkub-fronts/domain/signature';

import MandatGestion from '../../../ui/web/template/mandat-gestion/mandat-gestion';

export interface MandatGestionFeatureProps {
  sign1Ref: any;
}

const MandatGestionFeature = (props: MandatGestionFeatureProps) => {
  const { sign1Ref } = props;

  const dispatch = useDispatch<AppDispatch>();

  const [patchProject] = usePatchProjectMutation();

  const { isSignature, signature, signatures } = useSelector(
    (state: RootState) => state.signature
  );

  const project = useSelector((state: RootState) => getCurrentProject(state));

  const [body, setBody] = useState<string>();
  const [lastName, setLastName] = useState<string>();
  const [firstName, setFirstName] = useState<string>();
  const [date] = useState<Date>(DateTime.local() as FixMe);

  /**
   * INIT
   */
  useEffect(() => {
    if (!project) return;
    if (!body)
      setBody(
        project.mandatGestion?.body
          ? project.mandatGestion?.body
          : "Atteste donner mandat à la société Greenkub SAS immatriculée sous le numéro 798 802 377 au registre du commerce et des sociétés de Montpellier pour pouvoir effectuer la déclaration préalable de travaux ou le permis de construire nécessaire à l'installation de ma construction bois ou de mon extension."
      );
    if (!lastName)
      setLastName(
        project?.mandatGestion?.lastName
          ? project?.mandatGestion.lastName
          : project?.customer.lastName
      );
    if (!firstName)
      setFirstName(
        project?.mandatGestion?.firstName
          ? project?.mandatGestion.firstName
          : project?.customer.firstName
      );
  }, [project]);

  /**
   * EDITION
   */
  const updateData = () => {
    if (isSignature) return;
    const mandatGestion = {
      body,
      lastName,
      firstName,
      date,
    };
    patchProject({ projectId: project?.id, project: { mandatGestion } }).then(
      (resp: any) => {
        if (resp.error) {
          dispatch(addErrorMessage(resp.error));
        } else {
          dispatch(addPositiveMessage(resp.data));
        }
      }
    );
  };

  useDebounce(
    async () => {
      if (isSignature) return;
      updateData();
    },
    1000,
    [body, lastName, firstName, date]
  );

  return (
    <MandatGestion
      project={project as Project}
      isSignature={isSignature}
      signature={signature}
      signatures={signatures}
      handleOpenModalSignHandler={(index: number) =>
        dispatch(openModalSignature({ currentIndexSignature: index }))
      }
      sign1Ref={sign1Ref}
      lastName={lastName || ''}
      setLastName={setLastName}
      firstName={firstName || ''}
      setFirstName={setFirstName}
      setBody={setBody}
      body={body || ''}
      date={date as FixMe}
    />
  );
};

export default MandatGestionFeature;
